export default {
  translation: {
    "Access denied": "Доступ запрещен",
    Active: "Активен",
    "At least one role required": "Необходимо выбрать хотя бы одну роль",
    "Attention!": "Внимание!",
    "Authorization required": "Требуется авторизация",
    Cancel: "Отменить",
    Class: "Класс",
    "Click or drag the file/s to the area to upload":
      "Нажмите или перетащите файл/ы в область для загрузки. Возможна загрузка из буфера обмена.",
    Close: "Закрыть",
    Continue: "Продолжить",
    "Continue with data loss": "Продолжить с потерей данных?",
    "Created at": "Дата создания",
    "Created by": "Создал(а)",
    "Created successfully [entity]": "{{entity}} успешно создан(а)",
    Create: "Создать",
    DateFormat: "DD.MM.YYYY",
    DateTimeFormat: "DD.MM.YYYY HH:mm",
    Deactivated: "Деактивирован",
    Delete: "Удалить",
    "Delete [entity]": "Удалить {{entity}}",
    "Deleted successfully [entity]": "{{entity}} успешно удален(а)",
    Description: "Описание",
    "Display ID": "Display ID",
    "Edit [entity]": "Редактирование {{entity}}",
    Email: "Email",
    "Error loading [entity]": "Ошибка при загрузке {{entity}}",
    "Error saving [entity]": "Ошибка при сохранении {{entity}}",
    "Error when accessing the server": "Ошибка при обращении к серверу",
    "Field required": "Необходимо заполнить поле",
    "File modification": "Изменение файла",
    Finish: "Завершить",
    "First name": "Имя",
    Filter: "Фильтр",
    "Format: value": "Формат: {{value}}",
    "Incorrect format of received data":
      "Некорректный формат полученных данных",
    "Invalid data format:": "Неверный формат данных для {{file}}",
    "Invalid email": "Некорректный email",
    "Invalid page URL": "Неверный URL-адрес страницы",
    "Image modification": "Изменение изображения",
    "Last name": "Фамилия",
    Login: "Логин",
    "Sign In": "Войти",
    Logout: "Выйти",
    Management: "Управление",
    "Maximum number: count": "Максимальное количество: {{count}}",
    "Metadata editor": "Редактор метаданных",
    "Middle name": "Отчество",
    "Min value required": "Требуется значение не менее {{value}}",
    Name: "Название",
    "Navigation blocked": "Навигация заблокирована",
    "New [entity]": "Новый {{entity}}",
    No: "Нет",
    Password: "Пароль",
    "Please enter [field]": "Пожалуйста, введите {{field}}",
    Repeat: "Повторить",
    Reload: "Обновить",
    Role: "Роль",
    Roles: "Роли",
    Save: "Сохранить",
    "Server error": "Ошибка сервера",
    Status: "Статус",
    TimeFormat: "HH:mm:ss",
    Title: "Заголовок",
    "Unsaved changes warning": "Форма содержит несохраненные данные.",
    "Updated at": "Дата обновления",
    "Updated by": "Обновил(а)",
    "Updated successfully [entity]": "{{entity}} успешно обновлен(а)",
    Upload: "Загрузить",
    User: "Пользователь",
    Users: "Пользователи",
    UUID: "UUID",
    Yes: "Да",
  },
};
